import {
  ServiceResponse,
  ViewProfileResult,
} from "../../types/serviceInterfaces";
import { supabase } from "@/integrations/supabase/client";
import { handleServiceError } from "@/services/BaseService";

export async function incrementViewCount(
  profileId: string,
  anonymousId?: string | null,
  userId?: string | null
): Promise<ServiceResponse<ViewProfileResult>> {
  try {
    if (!profileId) {
      return {
        data: null,
        error: { category: "validation", message: "Profile ID is required" },
      };
    }

    console.log(
      `Calling record_profile_view for profile ${profileId}, anonymous: ${!!anonymousId}`
    );

    // Use the database function to record the view and handle throttling
    const { data, error } = await supabase.rpc("record_profile_view", {
      p_profile_id: profileId,
      p_user_id: userId || null, // Will be set by RLS to auth.uid() for authenticated users
      p_anonymous_id: anonymousId,
    });

    if (error) {
      return {
        data: null,
        error: handleServiceError(error, "profile_views"),
      };
    }

    return {
      data: { success: true },
      error: null,
    };
  } catch (error) {
    return {
      data: null,
      error: handleServiceError(error, "profile_views"),
    };
  }
}
